const scrollers = document.querySelectorAll(".wander-partner-scroller");

// If a user hasn't opted in for recuded motion, then we add the animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

function addAnimation() {
  scrollers.forEach((scroller) => {
    // add data-animated="true" to every `.scroller` on the page
    scroller.setAttribute("data-animated", true);

    // Make an array from the elements within `.scroller-inner`
    const scrollerInner = scroller.querySelector(".wander-scroller__inner");
    const scrollerContent = Array.from(scrollerInner.children);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}
$(document).ready(function () {
  // slider revoking after display none
  $("#regional-btn").on("click", function () {
    $(".wander-destination-sliderRegional").css("display", "block");
    $(".wander-destination-sliderRegional").slick("setPosition");
  });
  $("#local-btn").on("click", function () {
    $(".wander-destination-slider").css("display", "block");
    $(".wander-destination-slider").slick("setPosition");
  });
});

// slider
$(document).ready(function () {
  $(".wander-destination-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: false,
    nextArrow: ".wander-next",
    prevArrow: ".wander-prev",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  });

  $(".wander-destination-sliderRegional").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: false,
    nextArrow: ".wander-nextRegional",
    prevArrow: ".wander-prevRegional",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  });
  $(".wander-feature-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    focusOnSelect: true,
    infinite: true,
    nextArrow: ".wander-feature-next",
    prevArrow: ".wander-feature-prev",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 748,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  });
  // pdp slider
  $(".pdp-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: false,
    swipeToSlide: true,
    touchThreshold: 10,
    nextArrow: ".wander-next",
    prevArrow: ".wander-prev",
    responsive: [
      {
        breakpoint: 1000,
        settings: "unslick",
      },
    ],
  });
  // blog slider 01
  $(".blog-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: true,
    nextArrow: ".blog-next",
    prevArrow: ".blog-prev",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      // {
      //   breakpoint: 480,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     variableWidth: false,
      //   },
      // },
    ],
  });

  // blog slider 2

  $(".blog-slider2").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: true,
    nextArrow: ".blog-next2",
    prevArrow: ".blog-prev2",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      // {
      //   breakpoint: 480,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     variableWidth: false,
      //   },
      // },
    ],
  });

  $(".blog-slider3").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    infinite: true,
    nextArrow: ".blog-next3",
    prevArrow: ".blog-prev3",
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      // {
      //   breakpoint: 480,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     variableWidth: false,
      //   },
      // },
    ],
  });
});

$(document).ready(function () {
  $(".navbar-toggler").click(function () {
    $(".wander-header").toggleClass("white-bg");
    $("body").toggleClass("no-scroll");
    $(".navbar-toggler-icon").toggleClass("toggled");
  });

  // Add background to .wander-header when user scrolls, only if screen size is less than 992px
  $(window).scroll(function () {
    if ($(window).width() < 992) {
      if ($(this).scrollTop() > 0) {
        $(".wander-header").addClass("scrolled");
      } else {
        $(".wander-header").removeClass("scrolled");
      }
    }
  });

  // Check on resize as well
  $(window).resize(function () {
    if ($(window).width() >= 992) {
      $(".wander-header").removeClass("scrolled");
    } else {
      $(window).scroll();
    }
  });
});

$(document).ready(function () {
  // When the .btn-local is clicked
  $(".btn-local").click(function () {
    // Add 'active' class to .local-box and remove it from .region-box
    $(".local-box").addClass("active");
    $(".region-box").removeClass("active");

    // Show .dropdown-middle-box and hide .dropdown-middle-box-regional
    $(".dropdown-middle-box").show();
    $(".dropdown-middle-box-regional").hide();
  });

  // When the .btn-region is clicked
  $(".btn-region").click(function () {
    // Add 'active' class to .region-box and remove it from .local-box
    $(".region-box").addClass("active");
    $(".local-box").removeClass("active");

    // Hide .dropdown-middle-box and show .dropdown-middle-box-regional
    $(".dropdown-middle-box").hide();
    $(".dropdown-middle-box-regional").show();
  });

  $(".country-name-item").hover(
    function () {
      // Hover in
      $(".dropdown-right-feature").hide();
      $(".dropdown-right-card").show();
      $(".country-name-item").removeClass("hovered");
      $(this).addClass("hovered");
    },
    function () {
      // Hover out
      $(".dropdown-right-feature").show();
      $(".dropdown-right-card").hide();
      $(this).removeClass("hovered");
    }
  );
  $(".regional-name-item").hover(
    function () {
      // Hover in
      $(".dropdown-right-feature").hide();
      $(".dropdown-right-card").hide();
      $(".dropdown-right-card-region").show();

      // Remove 'hovered' class from all .regional-name-item
      $(".regional-name-item").removeClass("hovered");
      // Add 'hovered' class to the currently hovered item
      $(this).addClass("hovered");
    },
    function () {
      // Hover out
      $(".dropdown-right-feature").show();
      $(".dropdown-right-card").hide();
      $(".dropdown-right-card-region").hide();

      // Remove 'hovered' class from the currently hovered item
      $(this).removeClass("hovered");
    }
  );

  $(".btn-local, .btn-region").click(function () {
    // Show .dropdown-right-feature and hide .dropdown-right-card
    $(".dropdown-right-feature").show();
    $(".dropdown-right-card").hide();
    $(".dropdown-right-card-region").hide();
    $(".country-name-item, .regional-name-item").removeClass("hovered");
  });

  $("#mainSearchInput").on("click", function () {
    $("#searchModal").modal("show");
  });

  $(".searchInputStyle").on("focus", function () {
    var $wrapper = $(this).closest(".search-input-wrapper");
    $wrapper.find(".search-popup").show(); // Show the popup in the same wrapper
  });

  $(".searchInputStyle").on("blur", function () {
    var $wrapper = $(this).closest(".search-input-wrapper");
    // Use setTimeout to allow click events within the popup before it hides
    setTimeout(function () {
      $wrapper.find(".search-popup").hide(); // Hide the popup in the same wrapper
    }, 100);
  });

  // Optional: Prevent the popup from hiding if it's clicked
  $(".search-popup").on("mousedown", function (event) {
    event.preventDefault(); // Prevent the blur event from firing
  });

  // product listing page js
  $(".plan-data-row .data-tag").on("click", function (event) {
    event.preventDefault(); // Prevent the default anchor behavior
    var type = $(this).data("type");

    if (type === "unlimited") {
      $(".unlimited-data-row").show();
    } else {
      $(".unlimited-data-row").hide();
    }

    $(".plan-data-row .data-tag").removeClass("active");
    $(this).addClass("active");
  });
  $(".plan-validity-row .validity-tag").on("click", function (event) {
    event.preventDefault(); // Prevent the default anchor behavior

    // Remove the active class from all validity tags
    $(".plan-validity-row .validity-tag").removeClass("active");

    // Add the active class to the clicked validity tag
    $(this).addClass("active");
  });

  $(".accordion-item").on("show.bs.collapse", function () {
    $(this).addClass("open");
  });

  $(".accordion-item").on("hide.bs.collapse", function () {
    $(this).removeClass("open");
  });

  // mobile list modal js

  $(".modal-iphone-btn").addClass("active");
  $(".mobile-list").show();
  $(".modal-android-category").hide();

  // Handle iPhone button click
  $(".modal-iphone-btn").click(function () {
    $(this).addClass("active");
    $(".modal-android-btn").removeClass("active");
    $(".modal-android-category").hide();
    $(".mobile-list").show();

    // Reset Android category state
    $(".modal-android-category li").removeClass("active").show();
  });

  // Handle Android button click
  $(".modal-android-btn").click(function () {
    $(this).addClass("active");
    $(".modal-iphone-btn").removeClass("active");
    $(".modal-android-category").show();
    $(".mobile-list").hide();
  });

  // Handle Android category item click
  $(".modal-android-category li").click(function () {
    $(".modal-android-category li").hide();
    $(this).show().addClass("active");
    $(".mobile-list").show();
  });

  // testimonial slider animation
  // Select all elements with class .testimonial-slider-1 and .testimonial-slider-2
  const testimonialSliders = document.querySelectorAll(
    ".testimonial-slider-1, .testimonial-slider-2"
  );

  // Check if user prefers reduced motion
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addTestimonialAnimation();
  }

  function addTestimonialAnimation() {
    testimonialSliders.forEach((testimonialSlider) => {
      // Add data-animated="true" attribute to each testimonial slider
      testimonialSlider.setAttribute("data-animated", true);

      // Select the inner container for testimonials
      const testimonialWrapper = testimonialSlider.querySelector(
        ".testimonial-wrapper-1, .testimonial-wrapper-2"
      );

      // Clone each child element and append it to the inner container
      const testimonialContent = Array.from(testimonialWrapper.children);
      testimonialContent.forEach((item) => {
        const duplicatedItemTestimonial = item.cloneNode(true);
        duplicatedItemTestimonial.setAttribute("aria-hidden", true);
        testimonialWrapper.appendChild(duplicatedItemTestimonial);
      });

      // Add event listeners for hover
      testimonialSlider.addEventListener("mouseenter", () => {
        testimonialWrapper.style.animationPlayState = "paused";
      });

      testimonialSlider.addEventListener("mouseleave", () => {
        testimonialWrapper.style.animationPlayState = "running";
      });
    });
  }
});

window.scrollTo({
  behavior: "smooth",
});
